import classNames from "classnames";
import * as React from "react";

import { ButtonContainer } from "./Button.styles";

type Props<AsComponent extends React.ElementType> =
  React.ComponentPropsWithoutRef<AsComponent> & {
    as?: AsComponent;
    children?: React.ReactNode;
    $variant?: "primary" | "secondary";
    $size?: "medium" | "large";
    className?: string;
    disabled?: boolean;
  };

export const Button = <AsComponent extends React.ElementType = "button">({
  $size = "medium",
  $variant = "primary",
  as,
  children,
  className,
  disabled,
  ...asComponentProps
}: Props<AsComponent>) => {
  return (
    <ButtonContainer
      $variant={$variant}
      $size={$size}
      className={classNames(
        "relative inline-flex items-center justify-between",
        className,
      )}
      disabled={disabled}
      as={as}
      {...asComponentProps}
    >
      {children}
    </ButtonContainer>
  );
};
